import IwMenu from '../../components/app/IwMenu';
import {
    KeyboardArrowDown as KeyboardArrowDownIcon,
  } from '@mui/icons-material';
  import {
      Box,
      Button,
  } from '@mui/material';
  import scssVars from "../../../scss/variables.module.scss";
import { height } from '@mui/system';
const AddButton = ({items}) => {
    const buttonStyle = {
        color: scssVars.mainIconColor,
        borderColor: scssVars.borderGrey,
        ":hover": {
            color: scssVars.mainButtonHighlight,}
    }
    const iconStyle = {
        display: "flex",
        justifyContent: "center",
        width: 24,
        height: 24,
        marginRight: 1,
        alignItems: "center",
        backgroundColor: "#1876d2",
        color: "white",
        borderRadius: "50%",
        fontSize: "18px",
    }
    return (
        <IwMenu
            label={
                <Box>
                    <Button variant='outlined' sx={buttonStyle}>
                        <Box component="span" sx={iconStyle}>+</Box>
                        Add  
                        <KeyboardArrowDownIcon style={{marginLeft: 56,}}/>
                    </Button>
                </Box>
            }
            tooltipProps={{
            title: "Add Options",
            }}
            items={items}
        />
        
    );
}

export default AddButton;